import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Segment,
  Dimmer,
  Loader,
  List,
  Button,
  Image,
} from 'semantic-ui-react';
import { Empty } from '../views/Empty';
import { Error } from '../views/Error';
import { uiActions, workLogActions } from '../../actions/index';
import '../Common.css';
import './ActivityToday.css';
import Strings from '../../common/Strings';
import { exportSingleDateCsv } from '../../helpers/export';
import { getProjectWithId } from '../../helpers/project';
import Analytics from '../../analytics/Analytics';
import Events from '../../analytics/Events';
import {
  getFormattedStartTimestamp,
  getHoursFromMillis,
  getLoggedTime,
  getLoggedTimeFromMillis,
  getWorkLogBlocksByProject,
  getWorkLogsSortedByStartTimestamp,
} from '../../helpers/workLog';
import Constant from '../../common/Constant';
import { getTimerText } from '../../helpers/timer';
import { history } from '../../helpers';
import { IconSelector } from '../views/IconSelector';

const moment = require('moment');

class ActivityToday extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      intervalId: '',
    };
  }

  componentWillMount() {
    this.updateInterval(this.props);
  }

  componentWillReceiveProps(newProps) {
    this.updateInterval(newProps);
  }

  componentWillUnmount() {
    if (this.state.intervalId) {
      clearInterval(this.state.intervalId);
    }
  }

  onExportClicked = () => {
    Analytics.logEvent(Events.EXPORT_TODAY);
    exportSingleDateCsv(moment(), this.props.workLogs);
  };

  onLogHoursClicked = () => {
    Analytics.logEvent(Events.CLICK_LOG_TODAY);
    this.props.dispatch(uiActions.workLogBlockClicked());
    this.props.dispatch(uiActions.activityAddTimeClicked());
    this.props.dispatch(uiActions.activityAddClicked(true));
  };

  onWorkLogClicked = workLog => {
    const project = getProjectWithId(workLog.projectId);
    this.props.dispatch(uiActions.workLogBlockClicked());
    this.props.dispatch(uiActions.activityAddTimeClicked(project, workLog));
  };

  onWorkLogBlockClicked = workLogBlockItem => {
    const project = getProjectWithId(workLogBlockItem.projectId);
    this.props.dispatch(uiActions.activityAddTimeClicked());
    this.props.dispatch(
      uiActions.workLogBlockClicked(project, workLogBlockItem.workLogs),
    );
  };

  updateInterval(props) {
    const { status } = props.timer;
    if (status === Constant.TIMER_RUNNING) {
      const interval = setInterval(() => {
        this.forceUpdate();
      }, 1000);
      if (this.state.intervalId) {
        clearInterval(this.state.intervalId);
      }
      this.setState({ intervalId: interval });
    } else if (this.state.intervalId) {
      clearInterval(this.state.intervalId);
    }
  }

  fetchTodaysWorkLog = () => {
    this.props.dispatch(workLogActions.fetchTodaysWorkLog());
  };

  handleOnClickMode = () => {
    this.props.dispatch(uiActions.toggleTodayListMode(!this.props.listMode));
  };

  renderContent() {
    const { workLogs, workLogBlocks } = this.props;
    if (workLogs.length === 0) {
      return (
        <div>
          <Empty
            imageId="today-empty-image"
            image="/emoji/coffee.png"
            titleId="today-empty-title"
            title={Strings.ACTIVITY.emptyTitle}
            bodyId="today-empty-body"
            body={Strings.ACTIVITY.emptyBody}
          />
        </div>
      );
    }

    if (this.props.listMode) {
      const Children = workLogs.map((workLog, index) => {
        const project = getProjectWithId(workLog.projectId);
        return (
          <List.Item
            className="project-list-item"
            style={{ position: 'relative' }}
            key={workLog.id}
            onClick={() => this.onWorkLogClicked(workLog)}
          >
            <div
              style={{
                position: 'absolute',
                left: 16.5,
                top: index === 0 ? 25 : -10,
                bottom: -10,
                width: 1,
                backgroundColor: '#E0E0E0',
              }}
            />
            <div
              style={{
                position: 'relative',
                display: 'flex',
                flexDirection: 'row',
                margin: 0,
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexShrink: '0',
                  width: 14,
                  height: 14,
                  borderRadius: 7,
                  backgroundColor: project.color,
                  marginRight: 10,
                  marginTop: 15,
                }}
              />
              <div style={{ flexGrow: 1 }}>
                <p className="activity-today-list-item-timestamp">
                  {getFormattedStartTimestamp(workLog)}
                </p>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                  }}
                >
                  <p className="activity-today-list-item-title-dark">
                    {project.name}
                  </p>
                  <div style={{ flexGrow: 1 }} />
                  <p className="activity-today-list-item-title-dark">
                    {getLoggedTimeFromMillis(workLog.totalLoggedMillis)}
                  </p>
                </div>
                {workLog.notes && (
                  <p className="activity-today-list-item-notes">
                    {workLog.notes}
                  </p>
                )}
              </div>
            </div>
          </List.Item>
        );
      });

      const Footer = (
        <div style={{ position: 'relative' }}>
          <div
            style={{
              position: 'absolute',
              left: 16.5,
              top: -10,
              bottom: 12,
              width: 1,
              backgroundColor: '#E0E0E0',
            }}
          />
          <Image
            className="activity-today-list-bed-image"
            src="/emoji/bed.png"
          />
        </div>
      );

      return (
        <div className="activity-today-list">
          {Children}
          {Footer}
        </div>
      );
    }

    const Children = workLogBlocks.map(workLog => {
      const project = getProjectWithId(workLog.projectId);
      const companyName = project.companyName ? project.companyName : '';
      return (
        <List.Item
          className="project-list-item"
          style={{
            backgroundColor: project.color,
            height: Math.max(
              50,
              getHoursFromMillis(workLog.totalLoggedMillis) * 80,
            ),
          }}
          key={workLog.id}
          onClick={() => this.onWorkLogBlockClicked(workLog)}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              margin: 0,
            }}
          >
            <div>
              <p className="activity-today-list-item-title">{project.name}</p>
              <p className="activity-today-list-item-subtitle">
                {getLoggedTime(workLog)}
              </p>
            </div>
            {companyName && (
              <Image
                className="project-list-item-linked-image"
                src="/icon/linked-white.png"
              />
            )}
          </div>
        </List.Item>
      );
    });

    return <div className="activity-today-list">{Children}</div>;
  }

  renderHeaderOrError() {
    if (this.props.failed) {
      return (
        <Error
          title={Strings.ACTIVITY.failedTitle}
          body={Strings.ACTIVITY.failedBody}
          buttonText={Strings.COMMON.tryAgain}
          buttonOnClick={this.fetchTodaysWorkLog}
        />
      );
    }

    const { workLogs } = this.props;
    const workLogsSize = workLogs.length;
    const projectsMap = new Map();
    let millis = 0;
    workLogs.forEach(workLog => {
      millis += workLog.totalLoggedMillis;
      projectsMap.set(workLog.projectId, workLog);
    });

    const hoursText = getLoggedTimeFromMillis(millis);

    let projectsText;
    if (projectsMap.size === 1) {
      projectsText = `${projectsMap.size} ${Strings.ACTIVITY.project}`;
    } else {
      projectsText = `${projectsMap.size} ${Strings.ACTIVITY.projects}`;
    }

    let activeTimer;
    if (this.props.timer.status !== Constant.TIMER_NOT_RUNNING) {
      const { color, name } = getProjectWithId(this.props.timer.projectId);
      activeTimer = (
        <List.Item
          id="active-timer-container-root"
          onClick={() => {
            const { dispatch } = this.props;
            dispatch(uiActions.menuItemClicked(1));
            history.replace('/timer');
          }}
        >
          <div className="active-timer-container">
            <div
              className="active-timer-icon-container"
              style={{ borderColor: color }}
            >
              <Image className="active-timer-icon" src="/icon/timer.svg" />
            </div>
            <div style={{ flex: 1 }}>
              <p id="active-timer-title">{Strings.TIMER.activeTimer}</p>
              <p id="active-timer-project-name">{name}</p>
            </div>
            <div id="active-timer-vertical-divider" />
            <p id="active-timer-value">{getTimerText(this.props.timer)}</p>
          </div>
        </List.Item>
      );
    }

    return (
      <List className="activity-today-list">
        <List.Item>
          <div className="activity-today-title-container">
            <h1 id="activity-today-title-text" className="activity-today-title">
              {Strings.ACTIVITY.today}
            </h1>
            <IconSelector
              listMode={this.props.listMode}
              onClickListMode={this.handleOnClickMode}
            />
            <div className="activity-today-title-space" />
            <Button
              id="activity-today-export-button"
              disabled={workLogsSize === 0}
              onClick={this.onExportClicked}
            >
              {Strings.PROJECT_DETAILS.export}
            </Button>
          </div>
          <div className="activity-today-divider" />
        </List.Item>
        <List.Item>
          <div
            id="activity-today-hours-container"
            className="activity-today-title-container"
          >
            <h1
              id="activity-today-hours-text"
              className="activity-today-header"
            >
              {hoursText}
            </h1>
            <div className="activity-today-title-vertical-divider" />
            <h1
              id="activity-today-projects-text"
              className="activity-today-header"
            >
              {projectsText}
            </h1>
            <div className="activity-today-title-space" />
            <Button
              id="add-button"
              className="common-green-button"
              onClick={this.onLogHoursClicked}
            >
              {Strings.ACTIVITY.logHours}
            </Button>
          </div>
        </List.Item>
        {activeTimer}
        {this.renderContent()}
      </List>
    );
  }

  render() {
    return (
      <div className="activity-today-root">
        <Segment basic className="activity-today-container">
          <Dimmer active={this.props.loading} inverted>
            <Loader inverted />
          </Dimmer>
          {this.renderHeaderOrError()}
        </Segment>
      </div>
    );
  }
}

ActivityToday.propTypes = {
  dispatch: PropTypes.func.isRequired,
  listMode: PropTypes.bool,
  loading: PropTypes.bool,
  failed: PropTypes.bool,
  workLogs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      totalLoggedMillis: PropTypes.number.isRequired,
      project: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        color: PropTypes.string.isRequired,
      }).isRequired,
    }),
  ),
  workLogBlocks: PropTypes.arrayOf(
    PropTypes.shape({
      totalLoggedMillis: PropTypes.number.isRequired,
      projectId: PropTypes.string.isRequired,
      workLogs: PropTypes.arrayOf(
        PropTypes.shape({
          totalLoggedMillis: PropTypes.number.isRequired,
          projectId: PropTypes.string.isRequired,
        }),
      ),
    }),
  ),
  projects: PropTypes.arrayOf(PropTypes.shape({})),
  timer: PropTypes.shape({
    status: PropTypes.string.isRequired,
    projectId: PropTypes.string.isRequired,
  }),
};

ActivityToday.defaultProps = {
  listMode: true,
  loading: true,
  failed: false,
  workLogs: [],
  workLogBlocks: [],
  projects: [],
  timer: {
    status: Constant.TIMER_NOT_RUNNING,
    projectId: '',
  },
};

const mapStateToProps = state => ({
  loading:
    state.uiState.isWorkLogTodayLoading || state.uiState.isProjectUpdating,
  failed: state.uiState.isWorkLogTodayFailed,
  workLogs: getWorkLogsSortedByStartTimestamp(state.workLogsToday),
  workLogBlocks: getWorkLogBlocksByProject(state.workLogsToday),
  projects: state.projects,
  timer: state.user.timer,
  listMode: state.listMode.todayList,
});

export default connect(mapStateToProps)(ActivityToday);



// WEBPACK FOOTER //
// ./src/components/activity/ActivityToday.js